<template>
  <div>
    <v-sheet :color="result.color" tile class="white--text text-center">
      <div :style="mobile ? 'height: 60px;' : 'height: 72px;'"></div>
      <p :class="mobile ? 'bold-30' : 'bold-50'" v-html="result.header"></p>
      <p
        v-if="result.subheader"
        :class="(mobile ? 'bold-20' : 'bold-28') + ' mb-5'"
        v-html="result.subheader"
      ></p>
      <div :style="mobile ? 'height: 24px;' : 'height: 32px;'"></div>
      <v-img contain :src="result.character" :height="mobile ? 199 : 320"></v-img>
    </v-sheet>

    <v-container :class="mobile ? 'pt-5' : 'pt-12'">
      <v-row justify="center">
        <v-col sm="12" md="8">
          <p :class="(mobile ? 'bold-24' : 'bold-32') + ' primary--text'">테스트 결과</p>
          <my-container class="score-board" style="background-color: #f2f2f2;">
            <v-row>
              <v-col cols="8" sm="8" md="4">총 문항 / 정답</v-col>
              <v-col cols="4" sm="4" md="2" class="text-right primary--text">{{ score }} / 10</v-col>
              <v-col cols="8" sm="8" md="4">언어 센스 지수</v-col>
              <v-col cols="4" sm="4" md="2" class="text-right primary--text">{{ score * 10 }}%</v-col>
            </v-row>
          </my-container>
          <div :style="mobile ? 'height: 30px;' : 'height: 40px;'"></div>
          <p :class="mobile ? 'bold-24' : 'bold-32'">{{ result.characteristicsTitle }}</p>
          <p
            v-for="(characteristic, index) in result.characteristics"
            :key="'chatacteristic' + index"
            :class="mobile ? 'regular-16' : 'regular-24'"
            style="color: #4f4f4f;"
          >👉 {{ characteristic }}</p>
          <div :style="mobile ? 'height: 30px;' : 'height: 40px;'"></div>
          <p :class="mobile ? 'bold-24' : 'bold-32'">{{ result.weaknessTitle }}</p>
          <p
            v-for="(weakness, index) in result.weaknesses"
            :key="'weakness' + index"
            :class="mobile ? 'regular-16' : 'regular-24'"
            style="color: #4f4f4f;"
          >👉 {{ weakness }}</p>
          <div :style="mobile ? 'height: 60px;' : 'height: 80px;'"></div>
          <my-button
            :color="result.color"
            depressed
            @click="openUrl('http://bit.ly/37oLmdz')"
          >{{ result.youtubeText }}</my-button>
          <div :style="mobile ? 'height: 20px;' : 'height: 32px;'"></div>
          <my-button :color="result.color" depressed @click="goHome()">내 성향 알아보러 가기</my-button>
          <div :style="mobile ? 'height: 20px;' : 'height: 32px;'"></div>
          <share-container></share-container>
          <div style="height: 80px;"></div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import MyButton from "../components/MyButton";
import MyContainer from "../components/MyContainer";
import ShareContainer from "../components/ShareContainer";

export default {
  components: { MyButton, MyContainer, ShareContainer },
  data: () => ({
    results: [
      {
        header: "시켜줘,<br />명예 원어민<br />🌟",
        color: "primary",
        character: require("../assets/character_genius.svg"),
        characteristicsTitle: "중국어 공부 비법 물어봐도 되나 혹쉬이~ 👀",
        characteristics: [
          "테스트로 측정 불가능한 재야의 고수!🐉",
          "중국어 공부 비법 좀 알려주실 수 있나요...",
          "간체자도, 성조도, 중국어 구성 요소는 기본으로 깔고가는 센스쟁이✌"
        ],
        weaknessTitle: "이렇게 완벽한 당신에게 필요한 건?",
        weaknesses: [
          "500만 개로 활용할 수 있는 ‘문형!’ (문장❌ ❌ ❌)",
          "문형에 넣을 수 있는 ‘생활 밀착형’ 단어!",
          "명예 말고 ‘진짜 원어민’으로 거듭나기 위한 발음 교정!"
        ],
        youtubeText: "오색중국어로 ‘찐’ 원어민 VIBE~ 느껴보기🎵"
      },
      {
        header: "중국어 공부,<br />어디서 쫌 하셨군요?<br />📖",
        color: "#14a172",
        character: require("../assets/character_robot.svg"),
        characteristicsTitle: "교양 과목으로 우아하게",
        characteristics: [
          "‘흑당마라어쩌구’ 같은 중국어 실력 🤔",
          "유행하는 건 다 때려 넣었으나 완성은 아님 ❌ ❌ ❌",
          "교양 수업 덕분에 ‘你吃饭了妈?’ 가 욕이 아니라는 것 정도는 알고 있음"
        ],
        weaknessTitle: "쫌쫌따리 구멍이 많은 당신에게 필요한 건?",
        weaknesses: [
          "하나만 알아도 무한 활용 가능한 ‘문형!’ (⚠문장 아님⚠)",
          "문형에 난 구멍을 메꿔줄 美친 단어량!",
          "대빵만한 발음 구멍을 한 번에 메꿔줄 피드백 지옥🔥"
        ],
        youtubeText: "중국어 지옥에서 만나 - 오색중국어가 🤗"
      },
      {
        header: "어화둥둥~~<br />우리 여섯 살 아기<br />🐥",
        color: "#f3af2e",
        character: require("../assets/character_collector.svg"),
        characteristicsTitle: "어여 튀어와요, 중국어의 늪 👋👋",
        characteristics: [
          "중국어가 세상에 존재한다는 건 앎 🇨🇳",
          "중국어 해봐! 하면 ‘니하오~'하면서 해맑게 웃음 🤧",
          "간단한 중국어 알려주면 손박수 👏쫚쫚👏 치면서 굉장히 좋아함"
        ],
        weaknessTitle: "이렇게 해맑기만 한 당신에게 필요한 건?",
        weaknesses: [
          "어떤 단어라도 끼워 넣을 수 있는 ‘문형!’ (문장<<<문형)",
          "문형에 끼워 넣을 바로 활용 가능한 ‘단어!’",
          "중국어 구성요소의 A to Z를 알려줄 쌩기초 강의!✍"
        ],
        youtubeText: "해맑기만 하지 말고 중국어 좀 배워봐✊"
      },
      {
        header: "요런 인간은 없었다,<br />중국어 교육계의 이단아<br />🤘",
        color: "#949495",
        character: require("../assets/character_civil.svg"),
        characteristicsTitle: "당신에게 중국어란? 가지 않은 길... 🛣",
        characteristics: [
          "중국어.. 후웅 난 그런 거 모루눈뒈~ 😯",
          "시간은 흐르고 있고~ 중국어 혼자 이렇게 그대로 있다 ~🎵",
          "중국어에 뭐가 있는지 알게 뭐람 🤔"
        ],
        weaknessTitle: "이렇게 백지장인 당신에게 필요한 건?",
        weaknesses: [
          "머리에 🏭문장 제작 공장🏭을 세워주는 ‘문형!’",
          "학습 의지 美친듯이 솟아나게 만드는 무한 스크롤 ‘발음 피드백!’",
          "이렇게까지 다양해도 되나 싶은 퀴즈 칭구칭긔📚📚📚"
        ],
        youtubeText: "중국어 바닥 생활 대탈출 by 오색중국어🌈"
      }
    ]
  }),
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    score() {
      return this.$route.query.score;
    },
    result() {
      switch (this.score) {
        case "10":
        case "9":
          return this.results[0];
        case "8":
        case "7":
        case "6":
          return this.results[1];
        case "5":
        case "4":
        case "3":
          return this.results[2];
        default:
          return this.results[3];
      }
    }
  },
  methods: {
    openUrl(url) {
      this.$amplitude.getInstance().logEvent("Button Youtube Clicked", { url });
      window.open(url, "_blank");
    },
    goHome() {
      this.$amplitude.getInstance().logEvent("Button Go Home Clicked");
      this.$router.push("/");
    }
  },
  created() {
    this.$amplitude.getInstance().logEvent("Page Result Viewed");
  }
};
</script>

<style>
</style>
